export { default } from 'features/payment/routes/cart-payment-redirect-route';
